const NS = 'PodcastLandingListWidget';
const CLS = 'podcastLandingListWidget';

import { handleListFilters } from '../../../../global/js/listsFilter';

export class PodcastLandingListWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.pageSize = 5; // zero-indexed
		this.listItems = this.$element.find(`.${CLS}-item`);
		this.dataMatched = this.$element.find(`[data-matched="true"]`);
		this.loadMoreButton = this.$element.find(`.load-more`);
		this.emptyResultText = this.$element.find(`.${CLS}-emptyResult`);
		this.currentLoad = this.$element.find(`.currentLoad`);
		// handles two filter names only atm (dates/topics), might be improved to be dynamic if needed
		this.filters = this.$element.find(`.${CLS}-filters select`);
		this.clearButton = this.$element.find(`.${CLS}-btnClearWrap button`);
		this.itemClassName = '.podcastLandingListItemWidget';
		handleListFilters(this);

		var count_elements = $(`[data-matched="true"]`).length;
		$(`.totalLoad`).text(count_elements);

		this.filters.change(function(){
			var count_elements = $(`[data-matched="true"]`).length;
			if(count_elements < 6){
				$(`.currentLoadMsg`).html("<span class='currentLoad'>"+count_elements+"</span> out of <span class='totalLoad'>"+count_elements+"</span> are showing");
			}
			else{
				$(`.totalLoad`).text(count_elements);
			}
		});

		this.currentLoad.text(6);
		var current = 6;
		this.loadMoreButton.on('click', function () {
			if(!$(`.podcastLandingListWidget-loadmore`).hasClass("d-none")){
				current += 6;
				$(`.currentLoad`).text(current);
			}
			else{
				$(`.currentLoadMsg`).html("<span class='currentLoad'>"+count_elements+"</span> out of <span class='totalLoad'>"+count_elements+"</span> are showing");
			}
		});

		this.clearButton.on("click",function(){
			var count_elements = $(`[data-matched="true"]`).length;
			$(`.currentLoad`).text(current);
			$(`.totalLoad`).text(count_elements);

		})
		
	}

}
